import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { getGroupDetails, getGroupsList } from "../../services/groups";
import { useProfileData } from "../../../hooks/useProfileData";
import { getUsersForGroups } from "../../services/users";

export const useGroupsListing = (entityId: number | null) => {
  const { i18n } = useTranslation();

  const {
    data: groupsListing,
    isLoading: isGroupsListingLoading,
    isError: isGroupListingHasError,
  } = useQuery({
    queryKey: ["EntityProfile", "GroupsListing", i18n.language, entityId],
    queryFn: async () => await getGroupsList(entityId),
    enabled: !!entityId,
  });

  return { groupsListing, isGroupsListingLoading, isGroupListingHasError };
};

export const useGroupDetails = () => {
  const { i18n } = useTranslation();
  const { groupId } = useParams();

  const { data: ownProfileData, isLoading: isProfileLoading } = useProfileData();
  const { entityId } = ownProfileData || {};

  const {
    data: groupDetails,
    isLoading: isGroupDetailsQueryLoading,
    isError: isGroupDetailsHasError,
  } = useQuery({
    queryKey: ["GroupDetails", i18n.language, entityId, groupId],
    queryFn: async () => await getGroupDetails(entityId, groupId),
    enabled: !!entityId && !!groupId,
  });

  const isGroupDetailsLoading = isProfileLoading || isGroupDetailsQueryLoading;

  return { groupDetails, isGroupDetailsLoading, isGroupDetailsHasError };
};

export const useGroupUsersList = ({ offset, searchText }: { offset: number; searchText: string }) => {
  const { i18n } = useTranslation();

  const {
    data: usersList,
    isLoading: iseUsersListLoading,
    isError: isUsersListHasError,
  } = useQuery({
    queryKey: ["GroupDetails", "UsersList", i18n.language, offset, searchText],
    queryFn: async () => await getUsersForGroups(offset, searchText),
  });

  return { usersList, iseUsersListLoading, isUsersListHasError };
};
